export const DEFAULT_SCALE = "100";
export const PRINT_SCALE = "150";
